import ClientService2 from './ServiceEuthenia'

const ClientService = {
  fetchData(param) {
    return new Promise((resolve, reject) => {
      ClientService2(param)
        .then((response) => {
          resolve(response)
        })
        .catch((errors) => {
          reject(errors)
        })
    })
  },
}

export default ClientService
